import { useCallback, useEffect, useRef, useState } from 'react';

export default function usePhotoReading({ fetchResource, intervalMs = 3000, maxPolls = 40 }) {
  const [state, setState] = useState('idle');
  const [readings, setReadings] = useState([]);
  const [mergedChecks, setMergedChecks] = useState([]);
  const timer = useRef(null);
  const polls = useRef(0);

  useEffect(() => () => clearTimeout(timer.current), []);

  const poll = useCallback(async ids => {
    polls.current += 1;
    const r = await fetchResource({ method: 'GET', resource: `calendar/photos?ids=${ids.join(',')}` });
    const list = r.readings || [];
    setReadings(list);
    setMergedChecks(r.mergedChecks || []);
    const pending = list.some(x => x.status === 'queued' || x.status === 'reading');
    if (!pending && list.length) return setState(list.some(x => x.status === 'done') ? 'done' : 'failed');
    if (polls.current >= maxPolls) return setState('failed');
    timer.current = setTimeout(() => poll(ids), intervalMs);
  }, [fetchResource, intervalMs, maxPolls]);

  const start = useCallback(ids => {
    clearTimeout(timer.current);
    polls.current = 0;
    setState('reading');
    timer.current = setTimeout(() => poll(ids), intervalMs);
  }, [poll, intervalMs]);

  return { start, state, readings, mergedChecks };
}
